import React, { useState, useEffect } from 'react';
import { Row, Modal } from 'antd';
import classNames from 'classnames/bind';
import { SVGS } from '~/assets/assetsPath';
import CardAboutMe from '../../components/card-about-me';
import styles from './ShareCollab.module.scss';
import { useSelector } from 'react-redux';
import SocialShare from '~/components/SocialShare';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';
import { useNavigate } from 'react-router';

const cx = classNames.bind(styles);

const ShareCollab = () => {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.user.userInfo);
    const [isShowSocialShare, setIsShowSocialShare] = useState(false);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDanhSachDichVu');
        // eslint-disable-next-line
    }, []);
    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 6, children: 0 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            My QR
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>My QR</Row>
                    <div className={cx('right_container')}>
                        {userInfo?.is_collab ? (
                            <>
                                <Row justify="center" className={cx('header_text')}>
                                    Scan this QR code to join our collaborator system
                                </Row>
                                <Row justify="center">
                                    <img src={userInfo?.qr_code} alt="" />
                                </Row>
                                <Row justify="center" className={cx('footer_text')}>
                                    Share the QR code to invite to join the collaborator system
                                </Row>
                                <Row justify="center">
                                    <div className={cx('share_btn')} onClick={() => setIsShowSocialShare(true)}>
                                        <img src={SVGS.IconShare} alt="" />
                                        <span>Share</span>
                                    </div>
                                </Row>
                                {isShowSocialShare && (
                                    <Modal
                                        centered
                                        visible={isShowSocialShare}
                                        onCancel={() => setIsShowSocialShare(false)}
                                        maskClosable={false}
                                        footer={null}
                                        className="otp-modal"
                                        width={550}
                                    >
                                        <div style={{ padding: '20px 20px' }}>
                                            <SocialShare userInfo={userInfo} />
                                        </div>
                                    </Modal>
                                )}
                            </>
                        ) : (
                            <Row justify="center">You are not yet a Contributor</Row>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareCollab;
